var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"items":_vm.items,"loading":_vm.isLoading,"error-messages":_vm.error,"label":"Tipo de Pedido","item-text":"name","item-value":"key","clearable":"","outlined":"","dense":""},on:{"input":function($event){return _vm.$emit('input', _vm.item)}},model:{value:(_vm.item),callback:function ($$v) {_vm.item=$$v},expression:"item"}})
}
var staticRenderFns = []

export { render, staticRenderFns }